import React, {PureComponent, type ReactNode} from 'react'
import {CheckIcon} from '@heroicons/react/solid'

type CheckboxProps = {
    id?: string
    status?: boolean
    title?: string
    onChange: (event: boolean) => void
    disabled?: boolean
}

export class Checkbox extends PureComponent<CheckboxProps> {

    static defaultProps = {
        status: false,
        disabled: false
    };

    onChange = () => {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(!this.props.status);
        }
    }

    render(): ReactNode {

        return (
            <div className="flex items-center text-neutral-700 cursor-pointer mb-2">
                <div
                    className="bg-white border border-neutral-700 w-8 h-8 rounded shadow flex flex-shrink-0 justify-center items-center mr-2 cursor-pointer focus-within:border-neutral-500"
                    onClick={this.props.disabled ? () => {} : this.onChange}
                    onKeyDown={this.props.disabled ? () => {} : this.onChange}>
                    <CheckIcon
                        data-testid="checkbox-icon"
                        className={`text-primary h-5 w-5${this.props.status ? ' block' : ' hidden'}`}/>
                </div>
                {this.props.title ?
                    <span className={`text-sm ml-2 ${this.props.disabled ? 'text-neutral-500' : ''}`} onClick={this.props.disabled ? () => {} : this.onChange} onKeyDown={this.props.disabled ? () => {} : this.onChange}>{this.props.title}</span> : ''}
            </div>
        )
    }
}

